module.exports = __webpack_public_path__ + "static/claims1-e89f3f7e64cbac5763cd49f48865cf1d.svg";